<template>
    <div>
        <Loading :value="loading"></Loading>
        <v-dialog
                v-model="dialogAjoutBudget"
                width="70%"
                :persistent="true"
                transition="dialog-bottom-transition"
                scrollable
        >
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Planifier budget pour les travaux {{typeTrx.libelle}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <el-form
                            id="formBudget"
                            :model="formBudget"
                            :rules="rulesBudget"
                            ref="formBudget"
                            :label-position="labelPosition"
                            class="demo-form-inline"
                    >
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-layout row>
                                    <v-flex md3 class="mr-1">
                                        <el-form-item prop="dateMoisAn" label="Mois annee" required style="width:100%">
                                            <el-date-picker
                                                    format="MMMM-yyyy"
                                                    value-format="yyyy-MM"
                                                    v-model="formBudget.dateMoisAn"
                                                    type="month" id="dateMoisAn"
                                                    placeholder="Sélectionnez un mois"
                                                    style="width:100%">
                                            </el-date-picker>
                                        </el-form-item>
                                    </v-flex>

                                    <v-flex md4 class="mr-1">
                                        <el-form-item prop="ressource" label="Type de ressource" required style="width:100%">
                                             <el-select
                                                name="valeurSelect"
                                                clearable
                                                id="valeurSelect"
                                                v-model="formBudget.ressource"
                                                placeholder="Sélectionner un type ressource"
                                                style="width:100%"
                                              >
                                              <el-option v-for="item in listTypeRessource" :key="item.id" :label="item.libelle" :value="item.libelle">
                                            </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </v-flex>

                                    <!-- <v-flex md3 class="mr-1">
                                        <el-form-item prop="libelle" label="Liste " required style="width:100%">
                                            <el-select   filterable  allow-create
                                            default-first-option  v-model="formBudget.libelle"
                                             v-on:change="loadUniteProduit(formBudget.libelle)"
                                             placeholder="Selectionnez un élement de la liste" style="width:100%">
                                              <el-option
                                                  v-for="item in listeProduitBudget"
                                                  :key="item.id"
                                                  :label="item.libelle"
                                                  :value="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </v-flex>

                                    <v-flex md2 class="mr-1">
                                      <el-form-item prop="unite" label="Unité" required style="width:100%">
                                              <el-select
                                        name="valeurSelect"
                                        id="valeurSelect"
                                        v-model="formBudget.unite"
                                        :value="valeurUniteMateriel"
                                        style="width:100%"
                                      >
                                        <el-option :value="valeurUniteMateriel"
                                          >{{ valeurUniteMateriel }}
                                        </el-option>
                                      </el-select>
                                        </el-form-item>
                                    </v-flex> -->


                                    <v-flex md4 class="mr-1">
                                        <el-form-item prop="montant"  label="Montant " required style="width:100%">
                                            <el-input-number controls-position="right" v-model="formBudget.montant"  :min="5" ></el-input-number>
                                        </el-form-item>
                                    </v-flex>

                                    <v-flex md2>
                                        <el-form-item label="action" style="width:100%">
                                            <el-button type="primary" :disabled="!verifFormBudget"  @click="addListBudget(formBudget)">Ajouter</el-button>
                                        </el-form-item>
                                    </v-flex>


                                </v-layout>

                                    <v-flex xs12 class="text-xs-right">
                                          <v-tooltip top>
                                                <input
                                                 name="fileInputExcel"
                                                  type="file"
                                                  style="display:none"
                                                  ref="fileInputExcel"
                                                  accept="image/*"
                                                  v-on:change="onFileExcelPicked"
                                                />
                                                <v-btn
                                                    v-if="true"
                                                    slot="activator"
                                                    color="green"
                                                    @click.stop="$refs.fileInputExcel.click()"
                                                    dark
                                                >
                                                    Importer
                                                    <v-icon right>file_download</v-icon>
                                                </v-btn>Importer fichier excel
                                          </v-tooltip>

                                           <v-tooltip top>
                                          <v-btn
                                              v-if="true"
                                              slot="activator"
                                              color="orange"
                                              @click.stop="generateFileExcel()"
                                              dark
                                          >
                                              Générer
                                              <v-icon right>file_upload</v-icon>
                                          </v-btn>Générer un modèle
                                          </v-tooltip>
                                      </v-flex>

                                <v-layout row>
                                    <v-flex xs12>
                                        <el-table :data="tableBudget" style="width: 100%">
                                            <el-table-column prop="dateMoisAn" label="Annee mois"> </el-table-column>
                                            <el-table-column prop="ressource" label="Ressource" sortable> </el-table-column>
                                            <!-- <el-table-column prop="libelle" label="Libelle" sortable> </el-table-column>
                                            <el-table-column prop="unite" label="Unité" sortable> </el-table-column> -->
                                            <el-table-column prop="montant" label="Montant proposé">
                                                <template slot-scope="scope">
                                                    {{new Intl.NumberFormat().format(scope.row.montant)}}
                                                </template>
                                            </el-table-column>


                                            <el-table-column label="Operations">
                                                <template slot-scope="scope">
                                                    <v-tooltip top>
                                                        <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableBudget)" dark>
                                                            <v-icon center>delete</v-icon>
                                                        </v-btn>
                                                        Supprimer
                                                    </v-tooltip>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </el-form>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat="flat" @click.native="closeDialog()">Annuler</v-btn>
                    <v-btn color="green darken-1" flat="flat" @click.native="createBudget()">Enregistrer</v-btn>
                </v-card-actions>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <LoadTypeBudgetExcel
          @close="showModalLoadBudget =false;loadListeTravaux();closeDialog();"
          :show="showModalLoadBudget"
          :idChantier="idChant"
          :typeTrx = this.typeTrx.id
          :listeTypeTravaux="lstBudget"
        ></LoadTypeBudgetExcel>

    </div>
</template>

<script>
    //function de difference de date

    var echarts = require("echarts/lib/echarts");
    require("echarts/lib/chart/bar");
    require("echarts/lib/chart/pictorialBar");
    require("echarts/lib/chart/funnel");
    require("echarts/lib/chart/sankey");
    require("echarts/lib/chart/scatter");
    require("echarts/lib/component/tooltip");
    require("echarts/lib/component/title");
    import html2canvas from "html2canvas";
    import Loading from "@/components/Loading";
    import LoadTypeBudgetExcel from "@/components/boardChantier/loadBudget.vue";

    export default {
        components: {
            Loading,
            LoadTypeBudgetExcel
        },
        props:{
            show:{
                type: Boolean
            },
            typeTrx:{
                type: Object
            },
            idChant: {
                type: Number
            }

        },
        name: "AjoutPrevisionBudgetChantier",
        data() {
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
                droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
                loading: false,

                //VARIABLE
                dialogAjoutBudget: false,
                IdTypeSelct: "",
                formBudget:{
                    dateMoisAn: null,
                    unite: null,
                    ressource: "",
                    libelle: "",
                    montant: 5
                },
                rulesBudget:{
                    dateMoisAn: [{ required: true, message: "Veuillez selectionner" }],
                    // libelle: [{ required: true, message: "Veuillez selectionner" }],
                    // montant: [{ required: true, message: "Veuillez saisir" }],
                    ressource:[{ required: true, message: "Veuillez selectionner" }],
                    unite:[{ required: true, message: "Veuillez selectionner" }]
                },
                datePickerRtp:{
                    // disabledDate(date){
                    //     console.log("date descatice ===")
                    //     return date > (new Date())
                    // }
                },
              valeurUniteMateriel:'',
              showModalLoadBudget: false,

              //Importer fichier excel
              fileExcel: [],
              lstBudget: [],
              listeBudgetSupp:[],

                listeProduitBudget:[],
                listeProduitAffich:[],
                tableBudget:[],
                listTypeRessource: [],
                labelPosition: 'top'


            };
        },
        computed: {
            verifFormBudget: function(){
                if(this.formBudget.dateMoisAn != null && this.formBudget.ressource != "" && this.formBudget.montant != ""  ){
                    return true;
                }
                else{
                    return false;
                }

            }
        },
        watch:{
            show: function(newValue, oldValue){
                if(newValue == true){
                    let _this = this;
                    this.listeBudgetSupp = [];
                    _this.loadListeTravaux()
                    this.tableBudget.splice(0)
                    let detailBudget = this.typeTrx.detailBudget
                    detailBudget.forEach((item)=>{
                        _this.tableBudget.push(item)
                    })

                   this.dialogAjoutBudget = true;
                   this.loadTypeRessource()

                  //  this.loadProduitBudget();
                    this.formBudget = {
                        libelle: "",
                        montant: 5,
                        ressource:''
                    }

                }else{
                    this.dialogAjoutBudget = false;
                }
            }
        },
        methods: {
            resetForm(){
                this.$refs["formBudget"].resetFields();
            },

            deleteRow(index, rows) {
              // enregistrer lid du lot de travaux supprimer dans la liste
                    this.listeBudgetSupp.push(this.tableBudget[index]);
                rows.splice(index, 1);
            },
            loadUniteProduit(item) {
                  let valeur;
                  this.valeurUniteMateriel =''
                  valeur = this.listeProduitAffich.find(function(element) {
                    if (element.value == item) {
                      return element.unite;
                    }
                  });
                  this.valeurUniteMateriel = valeur.unite;
                },
                loadTypeRessource() {          
                    let url =this.domaine + "product/typeRessource";
                        this.$http.get(url).then(response => {
                        if (response.body) {
                            this.listTypeRessource = response.body.types;
                            this.loading = false;
                        }
                        });
                },
            loadTypeProduit() {
              this.loading = true;
              this.listeProduitBudget = []
              if (this.formBudget.ressource != 0) {
                let url =
                  this.domaine + "product/productSelect/type/" + this.formBudget.ressource;
                this.$http.get(url).then(
                  response => {
                    this.loading = false;
                    this.listeProduitBudget = response.body.produits;
                    this.listeProduitAffich = response.body.produits;
                  },
                  errRep => {
                    this.loading = false;
                    this.$message.error(
                      "Une erreur est survenue lors du chargement de la liste du chntier"
                    );
                  }
                );
              } else {
                this.loadProduitBudget();
                this.loading = false;
              }
            },

             loadListeTravaux(){
                this.loading = true;
                let url =  this.domaine + "budgetChantier/chantier/"+this.idChant;
                this.$http.get(url).then(
                    resp=>{
                        this.loading = false;
                        this.tableListeTrxBudget = resp.body.listeTypeTrx
                         this.totalMntPropose = resp.body.totalMntPropose;
                        this.totalMntValide = resp.body.totalMntValide;
                        this.totalTravauxEnAttente = resp.body.totalTravauxEnAttente;
                    },
                    error=>{
                        this.loading = false;
                        this.$message.error(
                            "Une erreur est survenue lors du chargement de la liste travaux du module compte exploitation"
                        );
                    }
                );
            },
            closeFormTypeProduit() {
              this.showModalLoadBudget = false;
              this.loadProduitBudget();
            },
            handleFileExcel(
              command //0=>Importer,1=>generer

            ) {
              switch (command) {
                case "0": //importer un fichier
                   this.$refs.fileInputExcel.click()
                  break;
                case "1": //generer un modele un fichier
                  this.generateFileExcel();
                  break;
                default:
                  this.$refs.fileInputExcel.click();
                break;
              }
            },
            generateFileExcel() {
              let url = this.domaine + "projet/generer/budget/modele";
              window.open(url);
            },
            onFileExcelPicked(event) {
              this.fileExcel.splice(0, 1);
              this.showModalLoadBudget = true;
              this.dialogAjoutBudget = false

              const files = event.target.files;
              let filename = files[0].name;
              if (filename.lastIndexOf(".xls") <= 0) {
                return alert("Veuillez selectionner un fichier excel valide ");
              }
              if (files[0].size > 1048576) {
                this.$message.error("La taille du fichier est supérieur à 1024 ko");
                return;
              }
              const fileReader = new FileReader();
              fileReader.addEventListener("load", () => {
                this.fileExcel.push(fileReader.result);
              });
              fileReader.readAsDataURL(files[0]);

              let url = this.domaine + "projet/loadBudget/excel";
              let data = new FormData();
              data.append("fichierExcel", files[0], files[0][name]);
              this.$http.post(url, data).then(
                resp => {
                  this.loading = false;
                  this.$notify({
                    title: "Chargement liste des budgets",
                    message: "Chargement effectué",
                    type: "success",
                    position: "top-right",
                    duration: 7000
                  });
                  this.lstBudget = resp.body.listeTypeTravaux;
                  this.showModalLoadBudget = true;
                },
                error => {
                  this.loading = false;
                  this.$message.error("Erreur lors de l'importation du fichier");
                }
              );


            },


            //budget
            loadProduitBudget()
            {
                this.loading = true;
                let url = this.domaine + "budgetProjet/liste";

                this.listeProduitBudget.splice(0);
                this.$http.get(url).then(
                    response => {
                        if (response.body) {
                            this.loading = false;
                            this.listeProduitBudget = response.body.produits;

                        }
                    },
                    response => {
                        this.loading = false;
                    }
                );
            },

            addListBudget(item){
                //verifier si l'item n'et pas deja enregistrer dans le tableau
                let eltProd =  this.tableBudget.find(elt => elt.libelle == item.libelle && elt.dateMoisAn  == item.dateMoisAn  );
                if(eltProd != null){
                    this.$message.error(
                        "Cet element a déjà été ajouté à la liste"
                    );
                    return;
                }
                this.tableBudget.push({
                    // libelle: item.libelle,
                    ressource: item.ressource,
                    // unite: this.valeurUniteMateriel,
                    montant: item.montant,
                    dateMoisAn: item.dateMoisAn
                })
              this.valeurUniteMateriel =''

                this.formBudget = {
                        libelle: "",
                        montant: 5
                }
            },

            resetForm(formName) {

                this.$refs[formName].resetFields();
            },

            headerRowStyle({row, rowIndex}) {
                return {"color":"black"};
            },
            format(percentage) {
                return `${percentage}%`;
            },


            getSumm(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Sous total";
                        return;
                    }

                    if (index === 4) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },



            //recherche info projet ou chantier
            submitForm() {
            },
            closeDialog() {
                this.$emit("close");
            },

            createBudget()
            {
                this.loading = true;
                let url = this.domaine+"budgetChantier/create/"+this.idChant;


                  let nbData = 10;
                let nbReq = 1;
                let ligne = null;

                let nbRest
                if (this.tableBudget.length > 10) {
                  nbData = 10;
                  nbReq = Math.round(this.tableBudget.length / nbData);
                  nbRest = this.tableBudget.length % nbData;
                  if (nbRest > 0) {
                    nbReq += 1;
                  }
                }

                for(let i=0; i<nbReq;i++)
                {
                    let initJ = i*nbData;
                    let finJ = (i + 1) * nbData;
                    let dataLot = [];
                    if(this.tableBudget.length > 0){
                        for(let j = initJ;j < finJ;j++){
                            if(this.tableBudget[j] == undefined){
                                break ;
                            }
                            dataLot.push(this.tableBudget[j]);
                        }
                    }
                    let data = new FormData();

                    for (let prop in dataLot) {
                        ligne = dataLot[prop];
                        data.append("option[annee][]", ligne.dateMoisAn);
                        data.append("option[ressource][]", ligne.ressource);
                        // data.append("option[libelle][]", ligne.libelle);
                        data.append("option[montant][]", ligne.montant);
                      }

                      data.append("listBudget", JSON.stringify(this.listeBudgetSupp));
                      data.append("typeTravauxId", this.typeTrx.id);
                      data.append("userId", this.user.id);

                    this.$http.post(url, data).then(
                        resp => {
                        this.closeDialog();
                        this.tableBudget.splice(0);
                        this.loading = false;
                        this.$notify({
                            title: "Budget",
                            message: "Budget enregistre avec succes",
                            type: "success",
                            position: "top-right",
                            duration: 7000
                        });

                        },
                        error => {
                            this.loading = false;
                            this.$message.error(
                                "Erreur lors de l'enregistrement des budjets"
                            );
                        }
                    )
                }    
            }
        },

        mounted() {

        }
    };
</script>

<style>
    tr td.el-table__expanded-cell {
        background-color:#EEEEEE;
    }



    td.el-table__expanded-cell div {
        background-color:#ffffff;
    }
</style>




// WEBPACK FOOTER //
// src/components/boardChantier/AjoutPrevisionBudgetChantier.vue